<template>
  <v-card>
    <v-card-title>Rekapan Anulir Siswa</v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-row>
          <v-col lg="12" cols="12">
            <v-btn
              role="a"
              target="_blank"
              :href="pdf_url"
              text
              color="red"
              dark
            >
              Export PDF
            </v-btn>
          </v-col>
          <v-col lg="3" cols="6">
            <v-autocomplete
              label="Rombel"
              v-model="filter.rombel_id"
              :items="data.rombel"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              :rules="[(v) => !!v || 'Silahkan pilih rombel']"
              clearable
              :error="!!!filter.rombel_id"
              hint="Silahkan pilih rombel"
            ></v-autocomplete>
          </v-col>
          <v-col :lg="filter.semester == '0' ? 3 : 5" cols="6">
            <v-select
              :items="[
                {
                  value: '1',
                  text: 'Ganjil (Juli - Desember)',
                },
                {
                  value: '2',
                  text: 'Genap (Januari - Juni)',
                },
                {
                  value: '0',
                  text: 'Lainnya / Per-Bulan',
                },
              ]"
              @change="
                options.page = filter.page = 1;
                get();
              "
              v-model="filter.semester"
              label="Semester"
              :rules="[(v) => !!v || 'Silahkan pilih opsi semester']"
              :error="!!!filter.semester"
              hint="Silahkan pilih opsi semester"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3" v-if="filter.semester == '0'">
            <v-select
              v-model="filter.bulan"
              @input="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Bulan"
              placeholder="Pilih Bulan"
              :rules="[(v) => !!v || 'bulan harus dipilih']"
              :items="data.bulan"
            ></v-select>
          </v-col>
          <v-col
            :cols="filter.semester == '0' ? 6 : 12"
            :lg="filter.semester == '0' ? 3 : 4"
          >
            <v-text-field
              type="number"
              v-model="filter.tahun"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Tahun"
              placeholder="Pilih Tahun"
              :rules="[(v) => !!v || 'tahun harus dipilih']"
            ></v-text-field>
          </v-col>
        </v-row>
        <button type="submit"></button>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Tanggal',
            value: 'tanggal',
          },
          {
            text: 'NIS',
            value: 'siswa.nis',
          },
          {
            text: 'Nama',
            value: 'siswa.nama',
          },
          {
            text: 'Rombel',
            value: 'siswa_rombel',
          },
          {
            text: 'Keterangan',
            value: 'keterangan',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.siswa_rombel" slot-scope="{ item }">
          {{ item.siswa ? item.siswa.rombel.rombel : "" }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      pdf_url: "",
      data: {
        siswa: [],
        rombel: [],
        bulan: [
          {
            value: 1,
            text: "Januari",
          },
          {
            value: 2,
            text: "Februari",
          },
          {
            value: 3,
            text: "Maret",
          },
          {
            value: 4,
            text: "April",
          },
          {
            value: 5,
            text: "Mei",
          },
          {
            value: 6,
            text: "Juni",
          },
          {
            value: 7,
            text: "Juli",
          },
          {
            value: 8,
            text: "Agustus",
          },
          {
            value: 9,
            text: "September",
          },
          {
            value: 10,
            text: "Oktober",
          },
          {
            value: 11,
            text: "November",
          },
          {
            value: 12,
            text: "Desember",
          },
        ],
      },
      filter_siswa: {},
      tahun_ajaran_id: 0,
    };
  },
  created() {
    this.getBulanIni();
    this.getData();
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    getBulanIni() {
      const date = new Date();
      var bulan = date.getMonth() + 1;

      this.filter.tahun = date.getFullYear();
      this.filter.bulan = bulan;
    },
    getData() {
      this.data.rombel = [];
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.data.rombel.push({
            value: item.id,
            text: item.rombel,
          });
        });
      });

      this.$root.app.http.get("/api/tahunajaran").then((res) => {
        res.data.forEach((item) => {
          if (item.status == "aktif") {
            this.tahun_ajaran_id = item.id;
          }
        });
      });
    },
    get() {
      this.req = {};

      if (this.filter.rombel_id && this.filter.semester) {
        this.is.loading = true;
        if (this.filter.rombel_id == null) {
          this.filter.rombel_id = "";
        }
        this.$root.app.http
          .get("/api/siswa/anulir", this.filter)
          .then((res) => {
            this.datas = res.data;
            this.recordsTotal = res.recordsTotal;
            this.pdf_url = res.pdf_url;
            this.is.loading = false;
          });
      } else {
        this.datas = [];
        setTimeout(() => {
          this.is.loading = false;
        }, 600);
      }
    },
  },
};
</script>
